/* eslint-disable consistent-return */
/* eslint-disable object-curly-newline */
import React from 'react';
import * as _ from 'lodash';
import {
    BODY_COMPOSITION_DIMENSIONS,
    bodyCompositionValue,
    displayBodyCompositionUnit,
    formatBodyCompositionValue,
} from 'utilsModule/bodyComposition';
import moment from 'moment-timezone';
import { withStyles } from '@material-ui/styles';
import { withNamespaces } from 'react-i18next';
import { normalizeVitalsDecimals } from 'utilsModule/vital';
const footer = require('../../../../public/hb_powered_by_int.png');

const styles = () => ({
    container: {
        backgroundColor: 'white',
        width: '21cm',
        height: '29.7cm',
        overflow: 'hidden',
    },
    metadataTitle: {
        width: '40%',
        fontSize: 14,
    },
    metadataValue: {
        width: '60%',
        fontSize: 14,
    },
    tdHeader: {
        border: '1px solid black',
        borderCollapse: 'collapse',
        textAlign: 'left',
        fontSize: 12,
        fontWeight: 'bold',
        padding: 8,
    },
    td: {
        border: '1px solid black',
        borderCollapse: 'collapse',
        textAlign: 'left',
        fontSize: 12,
        padding: 8,
    },
    tdTotal: {
        border: '1px solid black',
        borderCollapse: 'collapse',
        textAlign: 'right',
        fontSize: 12,
        fontWeight: 'bold',
        padding: 8,
    },
    metadataSpace: {
        height: 10,
    },
    /**
     * Ten columns do not fit an A4 portrait page at the normal size, so an HS2S report with
     * body composition prints smaller and divides the width evenly instead of letting the
     * headings decide it.
     */
    tableCompact: {
        tableLayout: 'fixed',
        '& td': {
            fontSize: 9,
            padding: 4,
            wordBreak: 'break-word',
        },
    },
});

@withNamespaces('pdf', { wait: true })
@withStyles(styles, { index: 1 })
class PatientVitalReportComponent extends React.Component {
    KEY = 'patientVitalReport';

    constructor(props) {
        super(props);
        const sessionLanguage = _.get(props, ['location', 'query', 'session-language']);
        if (sessionLanguage) {
            props.i18n.changeLanguage(sessionLanguage);
        }
    }

    render = () => {
        const { classes } = this.props;
        return ( <
            div className = { classes.container } >
            <
            div style = {
                { padding: 20 } } > { this._header() } <
            div style = {
                { height: 20 } }
            /> { this._table() } { this._footer() } <
            /div> <
            /div>
        );
    };

    _header = () => {
        const { reportMetaData, classes, t } = this.props;
        if (!reportMetaData) return;
        return ( <
            div style = {
                {
                    width: '100%',
                }
            } >
            <
            div style = {
                { display: 'flex', justifyContent: 'center', alignItems: 'center' } } >
            <
            img src = { reportMetaData.hospitalLogo }
            style = {
                { width: 110, height: 110, marginTop: 12, marginBottom: 12 } }
            /> <
            /div> <
            div style = {
                {
                    width: '100%',
                    textAlign: 'center',
                    fontSize: 20,
                    fontWeight: 'bold',
                    fontFamily: 'Roboto',
                    marginTop: 12,
                    marginBottom: 12,
                }
            } >
            {t(`${this.KEY}.title`)} <
            /div> <
            table style = {
                { width: '100%' } } >
            <
            tr >
            <
            td className = { classes.metadataTitle } > {t(`${this.KEY}.meta.participantName`)} < /td> <
            td className = { classes.metadataValue } >: { reportMetaData.patient } < /td> <
            /tr> <
            tr >
            <
            td className = { classes.metadataTitle } > {t(`${this.KEY}.meta.participantIdAndNo`)} < /td> <
            td className = { classes.metadataValue } >
            : { reportMetaData.idType }
            / { reportMetaData.idNo } <
            /td> <
            /tr> <
            tr >
            <
            td className = { classes.metadataTitle } > {t(`${this.KEY}.meta.dateOfBirth`)} < /td> <
            td className = { classes.metadataValue } >: { reportMetaData.dateOfBirth } < /td> <
            /tr> <
            tr >
            <
            td className = { classes.metadataSpace }
            /> <
            td className = { classes.metadataSpace }
            /> <
            /tr> <
            tr >
            <
            td className = { classes.metadataTitle } > {t(`${this.KEY}.meta.providerName`)} < /td> <
            td className = { classes.metadataValue } >: { reportMetaData.provider } < /td> <
            /tr> <
            tr >
            <
            td className = { classes.metadataTitle } > {t(`${this.KEY}.meta.hospitalClinicName`)} < /td> <
            td className = { classes.metadataValue } >: { reportMetaData.hospital } < /td> <
            /tr> <
            tr >
            <
            td className = { classes.metadataTitle } > {t(`${this.KEY}.meta.programmeName`)} < /td> <
            td className = { classes.metadataValue } >: { reportMetaData.program } < /td> <
            /tr> <
            tr >
            <
            td className = { classes.metadataTitle } > {t(`${this.KEY}.meta.periodOfReportDate`)} < /td> <
            td className = { classes.metadataValue } >: { reportMetaData.periodReport } < /td> <
            /tr> <
            tr >
            <
            td className = { classes.metadataSpace }
            /> <
            td className = { classes.metadataSpace }
            /> <
            /tr> <
            tr >
            <
            td className = { classes.metadataTitle } > {t(`${this.KEY}.meta.dateAndTimeOfReport`)} < /td> <
            td className = { classes.metadataValue } >: { reportMetaData.dateOfReport } < /td> <
            /tr> <
            tr >
            <
            td className = { classes.metadataTitle } > {t(`${this.KEY}.meta.downloadedBy`)} < /td> <
            td className = { classes.metadataValue } >: { reportMetaData.downloadedBy } < /td> <
            /tr> <
            /table> <
            /div>
        );
    };

    _table = () => {
        const { classes, data, vitalGroupId, t } = this.props;
        const {
            location: {
                query: { skuName },
            },
        } = this.props;
        const vitalHeaders = this._getHeadersForVitalGroupId(vitalGroupId);
        const bodyCompositionColumns = this._bodyCompositionColumns(vitalGroupId, data);
        const totalColumns = vitalHeaders.columns.length + bodyCompositionColumns.length + 2;

        return ( <
            div style = {
                { height: '600px' } } >
            <
            table className = { bodyCompositionColumns.length ? classes.tableCompact : undefined }
            style = {
                { borderCollapse: 'collapse', width: '100%', marginBottom: '4%' } } >
            <
            tr >
            <
            td className = { classes.tdHeader }
            colSpan = { totalColumns } > { skuName || '' } <
            /td> <
            /tr> <
            tr >
            <
            td className = { classes.tdHeader }
            style = {
                { width: bodyCompositionColumns.length ? '13%' : '20%' } } >
            {t(`${this.KEY}.table.dateTimeTaken`)} <
            /td>

            { /* HEADERS */ } {
                vitalHeaders.columns.map((vitalHeader) => {
                    return ( <
                        td key = { vitalHeader }
                        className = { classes.tdHeader } > { vitalHeader } <
                        /td>
                    );
                })
            }

            { /* BODY COMPOSITION HEADERS */ } {
                bodyCompositionColumns.map((column) => {
                    return ( <
                        td key = { column.key }
                        className = { classes.tdHeader } > { column.label } <
                        /td>
                    );
                })
            }

            <
            td className = { classes.tdHeader } > {t(`${this.KEY}.table.schedule`)} < /td> <
            /tr> { /* DATA CELLS */ } {
                data.tasks.map((task) => {
                    return this._tableCell(task, vitalHeaders, bodyCompositionColumns);
                })
            }

            { /* PAGE AVERAGE */ } { this._tableCellAverage(vitalHeaders, data.summary, bodyCompositionColumns) }

            { /* TOTAL READINGS */ } { this._totalCell(totalColumns) } <
            /table> <
            /div>
        );
    };

    _totalCell = (totalColumns) => {
        const { classes, page, totalPages, reportMetaData, t } = this.props;
        if (+page !== +totalPages) return;
        return ( <
            tr >
            <
            td className = { classes.tdTotal }
            colSpan = { totalColumns } >
            {t(`${this.KEY}.table.totalReadings`, { total: reportMetaData.total })} <
            /td> <
            /tr>
        );
    };

    _tableCell = (task, vitalHeaders, bodyCompositionColumns = []) => {
        const { classes, reportMetaData, t } = this.props;
        return ( <
            tr >
            <
            td className = { classes.td } > {
                moment(task.completedAt)
                .tz(reportMetaData.timezone)
                .format('DD MMM YYYY, HH:mm')
            } <
            /td> {
                vitalHeaders.vitals.map((vital) => {
                    const observations = task.observationCompiled;
                    const observation = _.find(observations, (obs) => {
                        return obs.vitals.indexOf(vital) > -1;
                    });

                    if (!observation) {
                        return ( <
                            td key = { vital.name }
                            className = { classes.td } >
                            -
                            <
                            /td>
                        );
                    }

                    switch (vital) {
                        case 'BP':
                            const diaComponent = _.find(observation.component, (item) => {
                                return item.code.text === 'dia';
                            });
                            const sysComponent = _.find(observation.component, (item) => {
                                return item.code.text === 'sys';
                            });
                            const sys = normalizeVitalsDecimals(sysComponent.valueQuantity.value, 'Blood Pressure');
                            const dia = normalizeVitalsDecimals(diaComponent.valueQuantity.value, 'Blood Pressure');
                            return ( <
                                td key = { vital.name }
                                className = { classes.td } > { sys }
                                /{dia} {diaComponent.valueQuantity.unit} <
                                /td>
                            );

                        case 'HR':
                            const hr = normalizeVitalsDecimals(observation.valueQuantity.value, 'Heart Rate');
                            return ( <
                                td key = { vital.name }
                                className = { classes.td } > { hr }
                                {` ${t(`${this.KEY}.units.beatsPerMin`)}`} <
                                /td>
                            );

                        case 'BG':
                            const bg = normalizeVitalsDecimals(observation.valueQuantity.value, 'Blood Glucose');
                            return ( <
                                td key = { vital.name }
                                className = { classes.td } > { bg } { observation.valueQuantity.unit } <
                                /td>
                            );

                        case 'BTM':
                            const btm = normalizeVitalsDecimals(observation.valueQuantity.value, 'Body Temperature');
                            return ( <
                                td key = { vital.name }
                                className = { classes.td } > { btm } { observation.valueQuantity.unit } <
                                /td>
                            );

                        case 'PO':
                            const po = normalizeVitalsDecimals(observation.valueQuantity.value, 'Blood Oxygen');
                            return ( <
                                td key = { vital.name }
                                className = { classes.td } > { po } { observation.valueQuantity.unit } <
                                /td>
                            );

                        case 'HS':
                            const hs = normalizeVitalsDecimals(observation.valueQuantity.value, 'Body Weight');
                            return ( <
                                td key = { vital.name }
                                className = { classes.td } > { hs } { observation.valueQuantity.unit } <
                                /td>
                            );

                        case 'RR':
                            const rr = normalizeVitalsDecimals(observation.valueQuantity.value, 'Respiration Rate');
                            return ( <
                                td key = { vital.name }
                                className = { classes.td } > { rr } { observation.valueQuantity.unit } <
                                /td>
                            );

                        default:
                            return ( <
                                td key = { vital.name }
                                className = { classes.td } >
                                -
                                <
                                /td>
                            );
                    }
                })
            }

            { /* BODY COMPOSITION CELLS */ } {
                bodyCompositionColumns.map((column) => {
                    if (column.dimension) {
                        // Body Composition vital: one value per component, with its own unit.
                        const bcObservation = _.find(task.observationCompiled, (obs) => obs.vitals.indexOf('BC') > -1);
                        const measured = column.dimension === 'dailyCalorieIntake'
                            ? bcObservation && bcObservation.bodyComposition && bcObservation.bodyComposition.dailyCalorieIntake != null
                                ? { value: bcObservation.bodyComposition.dailyCalorieIntake, unit: 'kcal/day' }
                                : null
                            : bodyCompositionValue(bcObservation, column.dimension);
                        return ( <
                            td key = { column.key }
                            className = { classes.td } >
                            { measured ? `${formatBodyCompositionValue(column.dimension, measured.value, measured.unit)} ${displayBodyCompositionUnit(measured.unit)}` : '-' } <
                            /td>
                        );
                    }
                    return null;
                })
            } <
            td className = { classes.td } > { task.schedule.display } { task.type && task.type === 'one-time' && '(OTT)' } <
            /td> <
            /tr>
        );
    };

    _tableCellAverage = (vitalHeaders, summary, bodyCompositionColumns = []) => {
        const { classes, t } = this.props;
        const vitalGroupSummary = summary[vitalHeaders.vitalGroupName];

        const getSummaryForVital = (vital) => {
            switch (vital) {
                case 'BG':
                    return vitalGroupSummary.BG.bg ? `${normalizeVitalsDecimals(vitalGroupSummary.BG.bg, 'Blood Glucose')} ${vitalGroupSummary.BG.unit}` : '-';
                case 'BP':
                    return vitalGroupSummary.BP.sys && vitalGroupSummary.BP.dia ? `${normalizeVitalsDecimals(vitalGroupSummary.BP.sys, 'Blood Pressure')}/${normalizeVitalsDecimals(
            vitalGroupSummary.BP.dia,
            'Blood Pressure',
          )} ${vitalGroupSummary.BP.unit}` : '-';
                case 'HR':
                    return vitalGroupSummary.HR.hr ? `${normalizeVitalsDecimals(vitalGroupSummary.HR.hr, 'Heart Rate')} ${t(`${this.KEY}.units.beatsPerMin`)}` : '-';
                case 'BTM':
                    return vitalGroupSummary.BTM.btm ? `${normalizeVitalsDecimals(vitalGroupSummary.BTM.btm, 'Body Temperature')} ${vitalGroupSummary.BTM.unit
            }` : '-';
                case 'PO':
                    return vitalGroupSummary.PO.po ? `${normalizeVitalsDecimals(vitalGroupSummary.PO.po, 'Blood Oxygen')} ${vitalGroupSummary.PO.unit}` : '-';
                case 'HS':
                    return vitalGroupSummary.HS.hs ? `${normalizeVitalsDecimals(vitalGroupSummary.HS.hs, 'Body Weight')} ${vitalGroupSummary.HS.unit}` : '-';
                case 'RR':
                    return vitalGroupSummary.RR.rr ? `${normalizeVitalsDecimals(vitalGroupSummary.RR.rr, 'Respiration Rate')} ${vitalGroupSummary.RR.unit}` : '-';
            }
        };

        return ( <
            tr >
            <
            td className = { classes.tdHeader } > {t(`${this.KEY}.table.overallAverage`)} < /td> {
                vitalHeaders.vitals.map((vital) => {
                    return ( <
                        td key = { vital }
                        className = { classes.tdHeader } > { getSummaryForVital(vital) } <
                        /td>
                    );
                })
            }

            { /* No average for body composition: these are estimates of different kinds, and
                 an average of them would read as a measurement. */ } {
                bodyCompositionColumns.map((column) => {
                    // The Body Composition vital is graded per value, so it has a period average.
                    const average = column.dimension && summary.BC && summary.BC[column.dimension];
                    return ( <
                        td key = { column.key }
                        className = { classes.tdHeader } >
                        { average && average.value != null
                            ? `${formatBodyCompositionValue(column.dimension, average.value, average.unit)} ${displayBodyCompositionUnit(average.unit)}`
                            : '-' } <
                        /td>
                    );
                })
            } <
            td className = { classes.tdHeader }
            /> <
            /tr>
        );
    };

    _footer = () => {
        const { page, totalPages, t } = this.props;
        return ( <
            div >
            <
            div style = {
                { flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' } } >
            <
            div style = {
                { flex: 1 } } >
            <
            img src = { footer }
            style = {
                { width: '50%', float: 'right', marginRight: '-30px' } }
            /> <
            /div> <
            div style = {
                { flex: 1 } } >
            <
            span style = {
                { float: 'right', fontSize: 12 } } >
            {t(`${this.KEY}.footer.pageOf`, { page, totalPages })} <
            /span> <
            /div> <
            /div> <
            /div>
        );
    };

    /**
     * Body Composition columns: on Body Composition programmes (group 13) only. Body Weight
     * reports show the weight alone, even for an HS2S weighing.
     */
    _bodyCompositionColumns = (vitalGroupId, data) =>
        +vitalGroupId === 13 ? this._bodyCompositionVitalColumns(data) : [];

    /**
     * The Body Composition vital (group 13): every value is its own column. Cells carry the
     * unit, since masses are in lbs where the country weighs in pounds, so the heading drops the
     * "(kg)" the shared labels have.
     */
    _bodyCompositionVitalColumns = (data) => {
        const { t } = this.props;
        const withoutUnit = (label) => label.replace(/\s*\([^)]*\)\s*$/, '');
        const hasDci = _.some(data.tasks || [], (task) =>
            _.some(task.observationCompiled || [], (obs) => obs.bodyComposition && obs.bodyComposition.dailyCalorieIntake != null),
        );
        const labelKeys = {
            bcWeight: 'bodyWeight',
            bcBmi: 'bmi',
            bcBodyFat: 'bodyFat',
            bcBodyWater: 'bodyWater',
            bcMuscleMass: 'muscleMass',
            bcLeanMass: 'leanMass',
            bcBoneMass: 'boneMass',
            bcVisceralFat: 'visceralFat',
            bcBmr: 'bmr',
        };
        return [
            ...BODY_COMPOSITION_DIMENSIONS.map((dimension) => ({
                key: dimension,
                dimension,
                label: withoutUnit(t(`${this.KEY}.vitalHeaders.${labelKeys[dimension]}`)),
            })),
            ...(hasDci
                ? [{ key: 'dailyCalorieIntake', dimension: 'dailyCalorieIntake', label: withoutUnit(t(`${this.KEY}.vitalHeaders.dci`)) }]
                : []),
        ];
    };

    _getHeadersForVitalGroupId = (vitalGroupId) => {
        const { t } = this.props;
        switch (+vitalGroupId) {
            // BG
            case 1:
                return {
                    columns: [t(`${this.KEY}.vitalHeaders.bloodGlucose`)],
                    vitalGroupId,
                    vitalGroupName: 'BG',
                    vitals: ['BG'],
                };

                // BP HR
            case 2:
                return {
                    columns: [t(`${this.KEY}.vitalHeaders.bloodPressure`), t(`${this.KEY}.vitalHeaders.heartRate`)],
                    vitalGroupId,
                    vitalGroupName: 'BP_HR',
                    vitals: ['BP', 'HR'],
                };

                // PO HR
            case 3:
                return {
                    columns: [t(`${this.KEY}.vitalHeaders.spo2`), t(`${this.KEY}.vitalHeaders.heartRate`)],
                    vitalGroupId,
                    vitalGroupName: 'PO_HR',
                    vitals: ['PO', 'HR'],
                };

                // HS
            case 4:
                return {
                    columns: [t(`${this.KEY}.vitalHeaders.bodyWeight`)],
                    vitalGroupId,
                    vitalGroupName: 'HS',
                    vitals: ['HS'],
                };

                // BP
            case 5:
                return {
                    columns: [t(`${this.KEY}.vitalHeaders.bloodPressure`)],
                    vitalGroupId,
                    vitalGroupName: 'BP',
                    vitals: ['BP'],
                };

                // HR
            case 6:
                return {
                    columns: [t(`${this.KEY}.vitalHeaders.heartRate`)],
                    vitalGroupId,
                    vitalGroupName: 'HR',
                    vitals: ['HR'],
                };

                // PO
            case 7:
                return {
                    columns: [t(`${this.KEY}.vitalHeaders.spo2`)],
                    vitalGroupId,
                    vitalGroupName: 'PO',
                    vitals: ['PO'],
                };

                // BTM
            case 9:
                return {
                    columns: [t(`${this.KEY}.vitalHeaders.temperature`)],
                    vitalGroupId,
                    vitalGroupName: 'BTM',
                    vitals: ['BTM'],
                };

                // HILLROM
            case 10:
                return {
                    columns: [
                        t(`${this.KEY}.vitalHeaders.bloodPressure`),
                        t(`${this.KEY}.vitalHeaders.heartRate`),
                        t(`${this.KEY}.vitalHeaders.spo2`),
                        t(`${this.KEY}.vitalHeaders.temperature`),
                    ],
                    vitalGroupId,
                    vitalGroupName: 'HILLROM_WACSM',
                    vitals: ['BP', 'HR', 'PO', 'BTM'],
                };

                // HILLROM RR
            case 11:
                return {
                    columns: [
                        t(`${this.KEY}.vitalHeaders.bloodPressure`),
                        t(`${this.KEY}.vitalHeaders.heartRate`),
                        t(`${this.KEY}.vitalHeaders.spo2`),
                        t(`${this.KEY}.vitalHeaders.temperature`),
                        t(`${this.KEY}.vitalHeaders.respirationRate`),
                    ],
                    vitalGroupId,
                    vitalGroupName: 'HILLROM_WACSM_RR',
                    vitals: ['BP', 'HR', 'PO', 'BTM', 'RR'],
                };

                // Body Composition: all of its columns come from _bodyCompositionVitalColumns.
            case 13:
                return {
                    columns: [],
                    vitalGroupId,
                    vitalGroupName: 'BC',
                    vitals: [],
                };

            default:
                return [];
        }
    };
}

export default PatientVitalReportComponent;
